import React, { useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthProvider/AuthProvider';


export default function PrivateRoute({children}) {

    const {user, loading} = useContext(AuthContext);
    const location= useLocation();
    if(loading){
        return <div className='flex justify-center mt-10'>
         <progress className="progress w-56"></progress>
        </div>
     }
    if(user?.uid){
        return children;
    }
   
  return <Navigate to='/login' state={{from:location}} replace></Navigate>
}
